import {BACKEND_API} from '../middleware/backend'

export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAILURE = 'USERS_FAILURE';
export const USERS_COUNT_REQUEST = 'USERS_COUNT_REQUEST';
export const USERS_COUNT_SUCCESS = 'USERS_COUNT_SUCCESS';
export const USERS_COUNT_FAILURE = 'USERS_COUNT_FAILURE';
export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';
export const USERS_FIND_REQUEST = 'USERS_FIND_REQUEST';
export const USERS_FIND_SUCCESS = 'USERS_FIND_SUCCESS';
export const USERS_FIND_FAILURE = 'USERS_FIND_FAILURE';
export const USER_SAVE_REQUEST = 'USER_SAVE_REQUEST';
export const USER_SAVE_SUCCESS = 'USER_SAVE_SUCCESS';
export const USER_SAVE_FAILURE = 'USER_SAVE_FAILURE';
export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE';

export const loadUsers = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [USERS_REQUEST, USERS_SUCCESS, USERS_FAILURE],
			endpoint: "user/list",
			filter: filter
		}
	})
};

export const countUsers = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [USERS_COUNT_REQUEST, USERS_COUNT_SUCCESS, USERS_COUNT_FAILURE],
			endpoint: "user/count",
			filter: filter
		}
	})
};

export const loadUser = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [USER_REQUEST, USER_SUCCESS, USER_FAILURE],
			endpoint: `user/${id}`,
		}
	})
};

export const findUsers = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [USERS_FIND_REQUEST, USERS_FIND_SUCCESS, USERS_FIND_FAILURE],
			endpoint: "user/find",
			filter: filter
		}
	})
};

export const saveUser = (user) => (dispatch, getState) => {
	return dispatch({
		id: user.userId,
		user: user,
		[BACKEND_API]: {
			types: [USER_SAVE_REQUEST, USER_SAVE_SUCCESS, USER_SAVE_FAILURE],
			endpoint: 'user',
			body: user,
			silent: true
		}
	})
};


export const deleteUser = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [USER_DELETE_REQUEST, USER_DELETE_SUCCESS, USER_DELETE_FAILURE],
			endpoint: `user/${id}`,
			method: 'DELETE'
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/users.js